<template>
  <div
    class="bblayout"
    :class="{ 'is-iosapp': bridge.isIniOSApp, 'is-androidapp': bridge.isInAndroidApp }"
  >
    <Header />
    <div class="bblayout__content">
      <!-- 临时用车 -->
      <div class="car-rental car-rental--0" v-if="status == 0">
        <div class="car-rental__banner">
          <div class="car-rental__bannertitle">临时订阅</div>
          <div class="car-rental__bannerhint">即刻下订今明用车</div>
          <!-- <div class="car-rental__bannersmallfont">
            请您知晓，我们需要收集您的取车时间、车型和城市，并需要使用您的手机号，方便我们及时为您提供服务。
          </div> -->
        </div>
        <div class="qrcode">
          <div class="qrcode__text">
            <div>限时今明两天临期内用车需求</div>
            <div>可添加下方企业微信咨询</div>
          </div>
          <div class="">
            <img
              class="qrcode__img"
              src="https://hhstaticource.oss-cn-hangzhou.aliyuncs.com/web-static-source/subscribe/images/faq2page-zeekr-qrcode.png"
              alt=""
            />
          </div>
          <div class="qrcode__hint">截图保存图片，扫码添加@订阅体验官企业微信</div>
        </div>
      </div>
      <!-- 长期用车 -->
      <div class="car-rental car-rental--1" v-if="status == 1">
        <div class="car-rental__top_img">
          <img src="@/static/image/carrental/top_bg.png" alt="">
          <!-- <div class="car-rental__bannersmallfont">
            请您知晓，我们需要收集您的取车时间、车型和城市，并需要使用您的手机号，方便我们及时为您提供服务。
          </div> -->
        </div>
        <!-- <div class="car-rental__banner">
          <div class="car-rental__bannertitle">长期订阅</div>
          <div class="car-rental__bannerhint">按月持续用车享多重权益</div>
          <div class="car-rental__bannersmallfont">
            *请您知晓，我们需要收集您的取车时间、车型和城市，并需要使用您的手机号，方便我们及时为您提供服务。
          </div>
        </div> -->
        <div class="car-rental__title">用车信息</div>
        <div class="car-rental__kv">
          <div class="car-rental__key">手机号</div>
          <div class="car-rental__val">{{ phone }}</div>
        </div>
        <div class="car-rental__kv car-rental__kv--val regular-font">
          <div class="car-rental__key">订阅车型</div>
          <div class="car-rental__val car-rental__selectlist">
            <div
              class="car-rental__selectitem"
              :class="{ 'car-rental__selectitem--active': activeCarId == item.id }"
              @click="activeCarId = item.id"
              v-for="item in carList"
              :key="item.value"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
        <div class="car-rental__kv car-rental__kv--light">
          <div class="car-rental__key">订阅周期</div>
          <div
            class="car-rental__val hasrightarrow"
            :class="{ placehodler: !selectPeriod }"
            @click="openSelectPeriod"
          >
            {{ selectPeriod ? selectPeriod : "请选择，1个月起订" }}
          </div>
        </div>
        <div class="car-rental__kv car-rental__kv--light">
          <div class="car-rental__key">取车时间</div>
          <div
            class="car-rental__val hasrightarrow"
            @click="openSelectDate"
            :class="{ placehodler: !selectDateStr }"
          >
            {{ selectDateStr ? selectDateStr : "请选择" }}
          </div>
        </div>
        <div class="car-rental__kv car-rental__kv--ipt car-rental__kv--light">
          <div class="car-rental__key">用车城市</div>
          <div class="car-rental__val">
            <!-- {{ city }} -->
            <input v-model="city" class="city-input" />
          </div>
        </div>
        <div class="car-rental__title hasbar">
          <img  class="bg_00" src="@/static/image/carrental/bg_00_text.png" />
        </div>
        <!-- <div class="car-rental__iconlist car-rental__iconlist--city">
          <div
            class="car-rental__iconlist-item"
            v-for="(item, i) in cityIconList"
            :key="i"
          >
            <img class="car-rental__iconlist-img" :src="item.image" />
          </div>
          
        </div> -->
        <img  class="bg_01" src="@/static/image/carrental/bg_01_city.png" />
        <img class="bg_02" src="@/static/image/carrental/bg_02_text.png" alt="">
        <!-- <div class="city-hint">
          *月订用户可享受距离交通枢纽30公里内地址的免费上门取送车服务
        </div> -->
        <div class="car-rental__title hasbar">
          <img class="bg_03" src="@/static/image/carrental/bg_03_text.png" alt="">
        </div>
        <img class="bg_04" src="@/static/image/carrental/bg_04_car.png" alt="">
        <img class="bg_05" src="@/static/image/carrental/bg_05_text.png" alt="">
<div class="city-hint city-hint2">
          *长租享租金季度递减，租满一年后在上述月租金价格基础上每个月平均还省1000元。
        </div>
        <!-- <img
          class="car-rental__chart"
          src="https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/anniversary/subscribe-sdk-car-rental-chart.png"
          alt=""
        /> -->
        <div class="car-rental__title hasbar">
          <img class="bg_06" src="@/static/image/carrental/bg_06_text.png" alt="">
        </div>
        <img class="bg_07" src="@/static/image/carrental/bg_07_banner.png" alt="">
        <img class="bg_08" src="@/static/image/carrental/bg_08_banner.png" alt="">
        <img class="bg_09" src="@/static/image/carrental/bg_09_code.png" alt="">
        <!-- <div class="car-rental__iconlist">
          <div class="car-rental__iconlist-item" v-for="(item, i) in equityList" :key="i">
            <img class="car-rental__iconlist-img" :src="item.image" />
          </div>
        </div> -->
      </div>
    </div>
    <div class="bblayout__bottom" v-if="status == 1">
      <!-- <div class="simplebtn" @click="toConsultingPage">咨询</div> -->
      <div class="simplebtn simplebtn--highlight" @click="confirm">提交</div>
    </div>
    <SelectDate
      ref="selectDateRef"
      @ok="changeSelectDate"
    />
    <SelectPeriod
      ref="selectPeriodRef"
      :select-period-str="selectPeriod"
      @ok="changeSelectPeriod"
    />
  </div>
</template>
<script setup>
import SelectDate from "./component/selectDate.vue";
import SelectPeriod from "./component/selectPeriod.vue";
import Header from "./component/header.vue";
import { ref, onMounted, computed, watch } from "vue";
const bridge = window.bridge
import {
  getChooseTime,
  queryCarModelByCity,
  sublead,
  queryEnableCarModel,
} from "@/api/order";
import moment from "moment";
import { Toast, Dialog } from "vant";
import { useRouter } from "vue-router";
const router = useRouter();

const city = ref(null);
const cityCode = ref(null);
const status = ref(-1); // 0 短期用车 1 长期用车
const phone = ref(null); // 用户手机号
const activeCarId = ref(null); // 所选订阅车型id
const carList = ref([]); // 订阅车型列表
const cityIconList = Array.from({ length: 12 }).map((v, i) => ({
  image: `https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/anniversary/subscribe-sdk-city-${
    i + 1
  }.png`,
}));
const equityList = Array.from({ length: 8 }).map((v, i) => ({
  image: `https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/anniversary/subscribe-sdk-carrental-equity-icon${
    i + 1
  }.png`,
}));
onMounted(() => {
  status.value = /isLongPeriod/i.test(window.location.href) ? 1 : 0;
  bridge.getSubscriptionInfo().then((subscriptionInfo) => {
    if (subscriptionInfo.success) {
      phone.value = subscriptionInfo.phone;
      city.value = subscriptionInfo.cityName;
      cityCode.value = subscriptionInfo.cityCode;
      init();
    }
  });
  // todo test
  // phone.value = "18888888888";
  // city.value = "杭州";
  // cityCode.value = 179;
  // status.value = 1;
  // init();
  // 安卓app中通过bridge获取头部高度
  if (bridge.isInAndroidApp) {
    bridge.setStatusBar({ isTransparency: false });
    bridge.getStatusHeight().then((subscriptionInfo) => {
      if (subscriptionInfo.success) {
        setStatusHeight(subscriptionInfo.statusHeight / 2);
      }
    });
  }
});

const setStatusHeight = (statusHeight) => {
  const header = document.querySelector(".header");
  if (header) header.setAttribute("style", `padding-top:${statusHeight}px;`);
};

const init = () => {
  if (status.value == 0) {
    queryCarModelByCity({
      cityCode: cityCode.value,
    }).then((res) => {
      if (res.status === 200 && res.data.code === "0") {
        carList.value.splice(0);
        if (res.data.body?.length) {
          activeCarId.value = res.data.body[0].id;
          carList.value.push(
            ...res.data.body.map((v) => ({
              ...v,
              label: v.carModelSortName,
              value: v.id,
            }))
          );
        }
      }
    });
  } else {
    queryEnableCarModel().then((res) => {
      if (res.status === 200 && res.data.code === "0") {
        carList.value.splice(0);
        if (res.data.body?.length) {
          activeCarId.value = res.data.body[0].id;
          carList.value.push(
            ...res.data.body.map((v) => ({
              ...v,
              label: v.carModelSortName,
              value: v.id,
            }))
          );
        }
      }
    });
  }
};
const timeToNum = (time) => {
  const s = (time + "").split(":");
  return +s[0] * 60 + +s[1] || 0;
};
const numToTime = (num) => {
  return (
    (Math.floor(num / 60) + "").padStart(2, 0) +
    ":" +
    (Math.floor(num % 60) + "").padStart(2, 0)
  );
};
const selectDateRef = ref(null);
const selectPeriodRef = ref(null);
const selectDate = ref(null);
const selectDateStr = computed(() => {
  if (selectDate.value) {
    return selectDate.value.format("YYYY-MM-DD");
  }
  return "";
});
const changeSelectDate = (e) => {
  selectDate.value = e;
};
const selectPeriod = ref(null);
const changeSelectPeriod = (e) => {
  selectPeriod.value = e;
};
const openSelectDate = () => {
  selectDateRef.value.open(selectDate.value ? selectDate.value.toDate() : null);
};
const openSelectPeriod = () => {
  selectPeriodRef.value.open();
};
const toConsultingPage = () => {
  const path = window.location.href.replace(/\/sdk.*/, "") + "/sdk/Consulting";
  if (bridge.isInAndroidApp) {
    bridge.toRouter({ route: path });
  } else {
    bridge.navigate({ route: path });
  }
};
const toSuccessPage = () => {
  router.replace({
    name: "CarRentalSuccess",
  });
  // const path = window.location.href.replace(/\/sdk.*/, '') + '/sdk/CarRentalSuccess'
  // if (bridge.isInAndroidApp) {
  //   bridge.toRouter({ route: path })
  // } else {
  //   bridge.navigate({ route: path })
  // }
};
const confirm = () => {  
  let pickUpTime;
  let period;
  let returnBackTime;
  if (status.value == 0) {
    const date = new moment();
    if (todayStatus.value == 1) {
      date.add(1, "day");
    }
    pickUpTime = date.format("YYYY-MM-DD") + ` 00:00:00`;
  } else {
    if (!selectPeriod.value) {
      Toast("请选择订阅周期");
      return;
    }
    if (!selectDate.value) {
      Toast("请选择取车时间");
      return;
    }
    if (!city.value) {
      Toast("请输入用车城市");
      return;
    }
    pickUpTime = selectDate.value.format("YYYY-MM-DD HH:mm:ss");
    if (/^\d+个月$/.test(selectPeriod.value)) {
      period = parseInt(selectPeriod.value) * 30;
      const m = new moment(selectDate.value);
      m.add(period, "day");
      returnBackTime = m.format("YYYY-MM-DD HH:mm:ss");
    } else {
      period = selectPeriod.value;
    }
  }
  Dialog.confirm({
    title: '确认提交吗?',
    confirmButtonText: '确认提交',
    confirmButtonColor: '#e56e2f',
    cancelButtonText: '我再想想',
    cancelButtonColor: '#666',
    teleport: '.bblayout__content'
  }).then(() => {
    const carModel =
      carList.value.find((v) => v.id == activeCarId.value)?.carModel || undefined;
    const params = {
      // sourceChannel: , // 渠道来源。ios-ios，android-android，mp-微信小程序，app-订阅用户端，ali_mp-支付宝小程序，sdk-内嵌
      sourceType: status.value == 0 ? "TEMPORARY_VEHICLES" : "LONG_VEHICLES", // 留资类型。TEMPORARY_VEHICLES-临时用车，LONG_VEHICLES-长期用车
      contactPhoneNumber: phone.value, // 联系手机号
      sourcePhoneNumber: phone.value, // 手机号
      carModel, // 车型
      pickUpTime, // 取车时间，格式：%Y-%m-%d %H:%i:%s
      returnBackTime, // 还车时间，格式：%Y-%m-%d %H:%i:%s
      period, // 周期
      // cityCode: cityCode.value, // 城市编码（百度地图）
      city: city.value,
      sourceChannel: "sdk", // 渠道来源。ios-ios，android-android，mp-微信小程序，app-订阅用户端，ali_mp-支付宝小程序，sdk-内嵌
      // remark: , // 备注,不超过500个字符
    };
    sublead(params).then(
      (res) => {
        if (res.status === 200 && res.data.code === "0") {
          toSuccessPage();
        } else {
          Toast("提交失败");
        }
      },
      () => {
        Toast("提交失败");
      }
    );
  }, () => {})
};
</script>
<style lang="scss" scoped>
@import url("../../../public/font/font.scss");
@import url("@/style/bottombarlayout.scss");
@import url("@/style/simplebtn.scss");

.car-rental {

  &.car-rental--0 .car-rental__banner {
    background-image: url("https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/anniversary/subscribe-sdk-car-rental-bg--0.jpg");
  }

  &.car-rental--1 .car-rental__banner {
    background-image: url("https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/anniversary/subscribe-sdk-car-rental-bg--1.jpg");
  }
  .car-rental__top_img{
    position: relative;
    height: 738px;
    img{
      width: 750px;
      height: 738px;
    }
  }
}

.car-rental__banner {
  width: 100%;
  height: 680px;
  background: url("https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/anniversary/subscribe-sdk-car-rental-bg.png")
    center / cover no-repeat;
  color: #fff;
  box-sizing: border-box;
  padding: 112px 40px 0;
  position: relative;

  &::before {
    content: "";
    width: 100%;
    height: 40px;
    display: block;
  }
}

.car-rental__bannertitle {
  font-size: 42px;
  font-weight: 500;
}

.car-rental__bannerhint {
  font-size: 26px;
  margin-top: 12px;
  font-weight: 400;
}

.car-rental__bannersmallfont {
  color: #bebfc0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));
  font-size: 16px;
  line-height: 32px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 32px 16px 16px;
  padding-left: 36px;
  &::before {
    content: "*";
    width: 20px;
    text-align: center;
    position: absolute;
    left: 20px;
  }
}

.car-rental__title {
  color: #000000;
  font-size: 34px;
  line-height: 52px;
  padding: 40px 40px 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  &.hasbar::before {
    content: "";
    height: 40px;
    width: 12px;
    // border-radius: 5px;
    background-color: #ff5800;
    margin-right: 16px;
  }
}

.car-rental__kv {
  display: flex;
  color: #232323;
  font-size: 30px;
  align-items: center;
  justify-content: space-between;
  padding: 40px;
  position: relative;

  & + .car-rental__kv {
    &::after {
      content: "";
      height: 1px;
      background: #dedede;
      position: absolute;
      top: 0;
      left: 40px;
      right: 40px;
      transform: scale(1, 0.5);
    }
  }

  &.car-rental__kv--val {
    flex-direction: column;
    align-items: flex-start;

    .car-rental__key,
    .car-rental__val {
      width: 100%;
    }

    .car-rental__key {
      margin-bottom: 24px;
    }
  }

  &.car-rental__kv--light {
    padding: 22px 40px;

    & + .car-rental__kv--light {
      &::after {
        display: none;
      }
    }
  }
}

.car-rental__key {
  font-weight: 400;
  white-space: nowrap;
}

.car-rental__val {
  font-weight: 500;
  white-space: nowrap;
}

.car-rental__selectlist {
  display: flex;
  overflow: auto;
  flex-wrap: nowrap;
  padding-right: 1px;
  padding-bottom: 40px;
  margin-bottom: -40px;
}

.car-rental__selectitem {
  width: 140px;
  height: 54px;
  flex-shrink: 0;
  line-height: 54px;
  text-align: center;
  color: #232323;
  position: relative;
  font-size: 26px;
  border-radius: 27px;
  font-weight: 400;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 200%;
    height: 200%;
    box-sizing: border-box;
    border: 2px solid #64696b;
    transform: scale(0.5);
    transform-origin: top left;
    border-radius: 54px;
  }

  &.car-rental__selectitem--active {
    color: #fff;
    background: #232323;
    transform: translate3d(0, 0, 0);

    &::after {
      opacity: 0;
      display: none;
    }
  }

  & + .car-rental__selectitem {
    margin-left: 24px;
  }
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hasrightarrow {
  display: flex;
  align-items: center;

  &.placehodler {
    font-weight: 400;
    color: #b9bec0;
  }

  &::after {
    content: "";
    width: 12px;
    height: 12px;
    border-right: 2px solid #b9bec0;
    border-top: 2px solid #b9bec0;
    transform: rotate(45deg);
    margin-left: 14px;
  }
}

.car-rental__iconlist {
  font-weight: 500;
  font-size: 34px;
  display: flex;
  flex-wrap: wrap;
  padding: 0 40px 10px;
  margin-bottom: 16px;
  justify-content: flex-start;
  position: relative;
  &.car-rental__iconlist--city {
    padding-left: 60px;
    padding-right: 60px;
    margin-top: 30px;
    .car-rental__iconlist-item {
      padding-top: 0;
      padding-bottom: 20px;
    }
    .car-rental__iconlist-img {
      width: 124px;
    }
  }
}

.car-rental__iconlist-item {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 34px 0;
  width: 25%;
}

.car-rental__iconlist-text {
  font-size: 26px;
  line-height: 26px;
  color: #232323;
  padding-top: 16px;
  font-weight: 400;
}

.car-rental__iconlist-img {
  width: 100px;
}

// 设定沉浸式状态栏占位
.is-iosapp {
  .car-rental__banner::before {
    content: "";
    width: 100%;
    height: constant(safe-area-inset-top);
    height: env(safe-area-inset-top);
    // height: 100px;
    display: block;
  }
}

.is-androidapp {
  ::v-deep .header {
    padding-top: 50px;
  }

  .car-rental__banner::before {
    content: "";
    width: 100%;
    height: 50px;
    display: block;
  }
}

.city-input {
  outline: none;
  border: 0;
  text-align: right;
  display: block;
}
.car-rental__kv--ipt {
  .car-rental__key,
  .car-rental__val {
    width: 1%;
    flex-grow: 1;
    input {
      width: 100%;
    }
  }
}
.car-rental__chart {
  width: 100%;
  padding: 40px;
  box-sizing: border-box;
}
.city-hint {
  color: #979797;
  font-weight: 300;
  font-size: 20px;
  line-height: 32px;
  padding: 0 20px;
  padding-left: 36px;
}
.city-hint2{
  margin: 0 15px;
}
.qrcode {
  color: #232323;
  font-size: 34px;
  text-align: center;
  padding-bottom: 350px;
  background: url('https://zeekrlife-oss.oss-cn-hangzhou.aliyuncs.com/frontend/anniversary/subscribe-sdk-car-rental-bottombg.png') bottom center / 100% auto no-repeat;
}
.qrcode__img {
  width: 50%;
}
.qrcode__hint {
  margin-top: 45px;
  font-size: 24px;
  color: #7c7f80;
}
.qrcode__text {
  padding-top: 60px;
  padding-bottom: 140px;
  font-weight: bold;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 50px;
    margin: auto;
    width: 0;
    height: 0;
    border-top: 18px solid #ff5841;
    border-left: 18px solid rgba(0, 0, 0, 0);
    border-right: 18px solid rgba(0, 0, 0, 0);
  }
}
::v-deep .van-dialog {
  border-radius: 4px;
  width: 70vw;
}
::v-deep .van-dialog__header {
  padding: 80px 0;
}
::v-deep .van-dialog__footer {
  flex-direction: row-reverse;
  &::after {
    display: none;
  }
  .van-button::after,
  .van-button::before {
    display: none;
  }
}
.bg_00{
  width: 400px;
  
}
.bg_01{
  width: 670px;
  display: block;
  margin: 55px auto;
}
.bg_02{
  width: 660px;
  display: block;
  margin: 0 auto;
  margin-bottom: 60px;
}
.bg_03{
  width: 440px;
}
.bg_04{
  width: 685px;
  display: block;
  margin: 30px auto;
}
.bg_05{
  width: 660px;
  display: block;
  margin: 30px auto;
}
.bg_06{
  width: 400px;
}
.bg_07{
  width: 670px;
  display: block;
  margin: 30px auto;
}
.bg_08{
  display: block;
  margin: 30px auto;
  width: 670px;
}
.bg_09{
  width: 750px;
  margin-top: 80px;
  display: block;
}
</style>
